function before_add2cart(id_prod) {
    if (document.forms['prod'+id_prod].elements['produktart_key'+id_prod].value=='shop_produktart_zusammenstellbar') {
        //Zusammenstellbare Produkte
        var pids = document.forms['prod'+id_prod].elements['pids'+id_prod].value.split(",");
        anz = 0;
        for(n=0;n<pids.length;n++) {
            if (document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod]) {
                if (hx.is_numeric(document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].value)==false && document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].value!='') {
                    displayErrorBox(cpText.shop_form_nicht_numerisch + ' ' + cpText.prod_anzahl);
                    document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].focus();
                    return false;
                }
                else if (hx.is_numeric(document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].value)==true && document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].value!='') {
                    anz = anz + parseInt(document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].value,10);
                    if(parseInt(document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].value,10)<parseInt(document.forms['prod'+id_prod].elements['mindestmenge'+id_prod].value,10)) {
                        displayErrorBox(cpText.prod_mindestmenge_sorte_ist + ' '+document.forms['prod'+id_prod].elements['mindestmenge'+id_prod].value);
                        document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].focus();
                        return false;
                    }
                }
            }
        }
        if (parseInt(anz,10)<parseInt(document.forms['prod'+id_prod].elements['mindestmenge'+id_prod].value,10)) {
            displayErrorBox(cpText.prod_mindestmenge_sorte_ist + ' ' +document.forms['prod'+id_prod].elements['mindestmenge'+id_prod].value);
            return false;
        }

    } else {
        //Standard Produkte
        if (hx.is_numeric(document.forms['prod'+id_prod].elements['anzahl'+id_prod].value)==false) {
            displayErrorBox(cpText.shop_form_nicht_numerisch + ' ' + cpText.prod_anzahl);
            return false;
        }
        else if(parseInt(document.forms['prod'+id_prod].elements['anzahl'+id_prod].value,10)<parseInt(document.forms['prod'+id_prod].elements['mindestmenge'+id_prod].value,10)) {
            displayErrorBox(cpText.prod_mindestmenge_ist + ' ' +document.forms['prod'+id_prod].elements['mindestmenge'+id_prod].value);
            return false;
        }
    }
    return true;
}

function prodcalc(id_prod) {
    //Gesamtsumme zusammenstellbarer Sorten berechnen
    if (document.forms['prod'+id_prod].elements['produktart_key'+id_prod].value=='shop_produktart_zusammenstellbar') {
        var pids = document.forms['prod'+id_prod].elements['pids'+id_prod].value.split(",");
        anz = 0;
        for(n=0;n<pids.length;n++) {
            if (document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod]) {

                if (hx.is_numeric(document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].value)==true && document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].value!='') {
                    anz = anz + parseInt(document.forms['prod'+id_prod].elements['p'+pids[n]+'n'+id_prod].value);
                }
            }
        }
        document.getElementById('anz'+id_prod).innerHTML = anz;
        document.forms['prod'+id_prod].elements['anzahl'+id_prod].value = anz;
    }

    //Produktpreis ermitteln
    if (document.forms['prod'+id_prod].elements['anzahl'+id_prod]) {
        sum = '&nbsp;';
        if (hx.is_numeric(document.forms['prod'+id_prod].elements['anzahl'+id_prod].value)==true && document.forms['prod'+id_prod].elements['anzahl'+id_prod].value!='') {

            preis = document.forms['prod'+id_prod].elements['preis1_brutto'+id_prod].value;
            if (preis=='') preis = 0;

            if (parseInt(document.forms['prod'+id_prod].elements['anzahl'+id_prod].value,10)>0) {
                if (document.forms['prod'+id_prod].elements['prodoption'+id_prod]) {
                    opt = document.forms['prod'+id_prod].elements['prodoption'+id_prod].value;
                    preis = document.forms['prod'+id_prod].elements['preis'+opt+'_brutto'+id_prod].value;
                    if (preis=='') preis = document.forms['prod'+id_prod].elements['preis1_brutto'+id_prod].value;
                } else if (document.forms['prod'+id_prod].elements['menge1_staffel'+id_prod] && document.forms['prod'+id_prod].elements['menge1_staffel'+id_prod].value!='') {
                    if (parseInt(document.forms['prod'+id_prod].elements['menge1_staffel'+id_prod].value,10)<=parseInt(document.forms['prod'+id_prod].elements['anzahl'+id_prod].value,10)) {
                        preis = document.forms['prod'+id_prod].elements['preis1_staffel'+id_prod].value;
                        if (preis=='') preis = document.forms['prod'+id_prod].elements['preis1_brutto'+id_prod].value;
                    }
                }
                if (preis=='') preis = 0;
                sum = parseFloat(document.forms['prod'+id_prod].elements['anzahl'+id_prod].value)*parseFloat(preis);
                sum = replace(FormatKomma(sum,2),",",".");
                sum = hx.formatPreis(sum);
                sum = cpText.prod_preis + ' &euro; '+sum;
            }
        }
        document.getElementById('sum'+id_prod).innerHTML = sum;
    }
}
